import type { FaireProductEntity } from "../../entity_types/product";

export const p_vccqswa7rf: FaireProductEntity = {
  token: "p_vccqswa7rf",
  type: "product",
  name: '100 Piece Lobster Pick-Red-4.5"L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/b426f3c26a873f4c925521c6643f1fa37f5d6a3e6b30d4aec75b37be62e2876c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b013b8821dde9921ac45fff23092045922ebe54f3e81d83d6a1d2beffa02117.jpeg",
  ],
  priceDollars: 8,
  description:
    "Boost your entertaining game with these Lobster Picks! Perfect for hors d’oeuvres, cocktail garnishes, or seafood feasts, these picks bring a fun and Claw-some touch to any table. A must-have for any coastal-inspired gathering! Other styles of decorative picks available.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:13.483Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
